// Make → logo file in /public/logos (served locally, works offline in the desktop app)
const LOGOS = {
  "Acura": "acura",
  "Alfa Romeo": "alfa-romeo",
  "Aston Martin": "aston-martin",
  "Audi": "audi",
  "BMW": "bmw",
  "Bentley": "bentley",
  "Buick": "buick",
  "Cadillac": "cadillac",
  "Chevrolet": "chevrolet",
  "Chrysler": "chrysler",
  "Daewoo": "daewoo",
  "Dodge": "dodge",
  "Ferrari": "ferrari",
  "Fiat": "fiat",
  "Ford": "ford",
  "GMC": "gmc",
  "Geo": "geo",
  "Honda": "honda",
  "Hummer": "hummer",
  "Hyundai": "hyundai",
  "Infiniti": "infiniti",
  "Isuzu": "isuzu",
  "Jaguar": "jaguar",
  "Jeep": "jeep",
  "Kia": "kia",
  "Lamborghini": "lamborghini",
  "Land Rover": "land-rover",
  "Lexus": "lexus",
  "Lincoln": "lincoln",
  "Lucid": "lucid",
  "MINI": "mini",
  "Mazda": "mazda",
  "McLaren": "mclaren",
  "Mercedes-Benz": "mercedes-benz",
  "Mitsubishi": "mitsubishi",
  "Nissan": "nissan",
  "Polestar": "polestar",
  "Porsche": "porsche",
  "Ram": "ram",
  "Rivian": "rivian",
  "Saab": "saab",
  "Saturn": "saturn",
  "Subaru": "subaru",
  "Suzuki": "suzuki",
  "Tesla": "tesla",
  "Toyota": "toyota",
  "Volkswagen": "volkswagen",
  "Volvo": "volvo"
};

export const makeLogo = (make) => {
  const slug = LOGOS[make] || LOGOS[Object.keys(LOGOS).find((k) => k.toLowerCase() === String(make || "").toLowerCase())];
  return slug ? `/logos/${slug}.png` : null;
};
